const API_V1 = '/v1';
const AUTH = `${API_V1}/auth`;
const ADMIN = `${API_V1}/admin`;
const CUSTOMER = `${API_V1}/customer`;
const RESELLER = `${API_V1}/reseller`;
const VENDOR_PANEL = `${API_V1}/vendor-panel`;
const BUYER_PANEL = `${API_V1}/buyer-panel`;
const ADMIN_BILLING = `${ADMIN}/billing`;
const ADMIN_INVOICES = `${ADMIN}/invoices`;
const ADMIN_WITHDRAWALS = `${ADMIN}/withdrawals`;
const ADMIN_IMPERSONATE = `${ADMIN}/impersonate`;
const ADMIN_USERS = `${ADMIN}/users`;
const ADMIN_TOKENS = `${ADMIN}/tokens`;
const ADMIN_SETTINGS = `${ADMIN}/settings`;
const USERS = '/users';
export const BASE_ENDPOINTS = {
  API_V1,
  AUTH,
  ADMIN,
  CUSTOMER,
  ME: `${API_V1}/me`,
  USERS,
  TWO_FACTOR: `${AUTH}/2fa`,
  AUTH_PASSWORD_RESET: `${AUTH}/password/reset`,
  MAPS: "/api/v1/maps",
  ROLES: "/roles",
  PERMISSIONS: "/permissions",
  AUDIT_LOGS: `${API_V1}/audit-logs`,
  COUNTRIES: "/countries",
  CAMPAIGNS: "/campaigns",
  ORGANIZATIONS: `${API_V1}/organizations`,
  TEAMS: "/teams",
  MEMBERSHIPS: "/memberships",
  ACTIVE_CALLS: `${API_V1}/active-calls`,
  ADMIN_RESELLERS: `${ADMIN}/resellers`,
  ADMIN_CUSTOMERS: `${ADMIN}/customers`,
  ADMIN_DIDS: `${ADMIN}/dids`,
  ADMIN_PHONE_NUMBERS: `${ADMIN}/dids`,
  ADMIN_DID_PROVIDERS: `${ADMIN}/did-providers`,
  ADMIN_DID_SUSPENSIONS: `${ADMIN}/did-suspensions`,
  ADMIN_CAMPAIGNS: `${ADMIN}/campaigns`,
  ADMIN_BUYERS: `${ADMIN}/buyers`,
  ADMIN_CALL_VENDORS: `${ADMIN}/call-vendors`,
  ADMIN_CAMPAIGN_BUYERS: `${ADMIN}/campaign-buyers`,
  ADMIN_BUYER_GROUPS: `${ADMIN}/buyer-groups`,
  ADMIN_CDRS: `${ADMIN}/cdrs`,
  ADMIN_SOFIA_PROFILES: `${ADMIN}/sofia-profiles`,
  ADMIN_SOFIA_GATEWAYS: `${ADMIN}/sofia-gateways`,
  ADMIN_OUTBOUND_PROVIDERS: `${ADMIN}/outbound-providers`,
  ADMIN_PROVIDER_RATE_DECKS: `${ADMIN}/provider-rate-decks`,
  ADMIN_PROVIDER_TRUNKS: `${ADMIN}/provider-trunks`,
  ADMIN_TRUNKS: `${ADMIN}/trunks`,
  ADMIN_PROVIDER_RATES: `${ADMIN}/provider-rates`,
  ADMIN_RESELLER_DEFAULT_TRUNK: `${ADMIN}/reseller-default-trunk`,
  ADMIN_IPQS_CARRIER_BLOCKS: `${ADMIN}/ipqs/carrier-blocks`,
  ADMIN_IPQS_POLICY: `${ADMIN}/ipqs/policy`,
  ADMIN_FREESWITCH_SOFIA: `${ADMIN}/freeswitch/sofia`,
  ADMIN_FREESWITCH_SERVERS: `${ADMIN}/freeswitch/servers`,
  ADMIN_BILLING,
  ADMIN_INVOICES,
  ADMIN_WITHDRAWALS,
  ADMIN_IMPERSONATE,
  ADMIN_USERS,
  ADMIN_TOKENS,
  ADMIN_SETTINGS,
};

export const API_ENDPOINTS = {
  PUBLIC: {
    TENANT: `${API_V1}/public/tenant`,
    CAP_CONFIG: `${API_V1}/public/cap-config`,
    SIGNUP: {
      START: `${API_V1}/public/signup/start`,
      VERIFY_EMAIL: `${API_V1}/public/signup/verify-email`,
      KYC: `${API_V1}/public/signup/kyc`,
      SUBMIT: `${API_V1}/public/signup/submit`,
    },
    RESELLER_SIGNUP_INVITATION: `${API_V1}/public/reseller-signup/invitation`,
    RESELLER_SIGNUP: `${API_V1}/public/reseller-signup`,
  },
  AUTH: {
    LOGIN: `${BASE_ENDPOINTS.AUTH}/login`,
    REGISTER: `${BASE_ENDPOINTS.AUTH}/register`,
    ME: `${BASE_ENDPOINTS.ME}`,
    TWO_FACTOR: {
      GENERATE: `${BASE_ENDPOINTS.TWO_FACTOR}/setup`,
      ENABLE: `${BASE_ENDPOINTS.TWO_FACTOR}/enable`,
      STATUS: `${BASE_ENDPOINTS.AUTH}/security`,
      DISABLE: `${BASE_ENDPOINTS.TWO_FACTOR}/disable`,
      RESET_REQUEST: `${BASE_ENDPOINTS.TWO_FACTOR}/reset-request`,
      RESET_CONFIRM: `${BASE_ENDPOINTS.TWO_FACTOR}/reset-confirm`,
    },
    FORGOT_PASSWORD: `${BASE_ENDPOINTS.AUTH_PASSWORD_RESET}/request`,
    RESET_PASSWORD: `${BASE_ENDPOINTS.AUTH_PASSWORD_RESET}/confirm`,
    PROFILE: `${BASE_ENDPOINTS.AUTH}/profile`,
    PROFILE_EMAIL_REQUEST: `${BASE_ENDPOINTS.AUTH}/profile/email/request`,
    PROFILE_EMAIL_CONFIRM: `${BASE_ENDPOINTS.AUTH}/profile/email/confirm`,
    CHANGE_PASSWORD: `${BASE_ENDPOINTS.AUTH}/password/change`,
  },
  USERS: {
    PROFILE: `${BASE_ENDPOINTS.USERS}/profile`,
    LIST: `${BASE_ENDPOINTS.USERS}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.USERS}/${id}`,
    UPDATE_ROLE: (id: string) => `${BASE_ENDPOINTS.USERS}/${id}/role`,
    UPDATE_STATUS: (id: string) => `${BASE_ENDPOINTS.USERS}/${id}/status`,
  },
  ROLES: {
    LIST: `${BASE_ENDPOINTS.ROLES}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.ROLES}/${id}`,
    CREATE: `${BASE_ENDPOINTS.ROLES}`,
    UPDATE: (id: string) => `${BASE_ENDPOINTS.ROLES}/${id}`,
    DELETE: (id: string) => `${BASE_ENDPOINTS.ROLES}/${id}`,
  },
  PERMISSIONS: {
    LIST: `${BASE_ENDPOINTS.PERMISSIONS}`,
  },
  MAPS: {
    TILES: `${typeof window !== 'undefined' ? window.location.origin : ''}/api/v1/maps/tiles`,
  },
  AUDIT_LOGS: {
    LIST: `${BASE_ENDPOINTS.AUDIT_LOGS}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.AUDIT_LOGS}/${id}`,
  },
  DASHBOARD: {
    CALL_TICKER: `${API_V1}/call-ticker`,
    ADMIN: {
      SUMMARY: `${API_V1}/admin/dashboard/summary`,
      TOP_CUSTOMERS: `${API_V1}/admin/dashboard/top-customers`,
      RECENT_LEDGER: `${API_V1}/admin/dashboard/recent-ledger`,
      CALLS_TIMESERIES: `${API_V1}/admin/dashboard/calls-timeseries`,
      LIVE_CALLS_TIMESERIES: `${API_V1}/admin/dashboard/live-calls-timeseries`,
      SYSTEM_STATUS: `${API_V1}/admin/system-status`,
    },
    CUSTOMER: {
      STATS: `${API_V1}/customer/dashboard`,
      CALLS_TIMESERIES: `${API_V1}/customer/dashboard/calls-timeseries`,
      BILLING_SUMMARY: `${API_V1}/customer/billing/summary`,
      CAMPAIGNS: `${API_V1}/customer/campaigns`,
      CAMPAIGN_ANALYTICS: (id: string) =>
        `${API_V1}/customer/campaigns/${encodeURIComponent(id)}/analytics`,
    },
    RESELLER: {
      BILLING_SUMMARY: `${API_V1}/reseller/billing/summary`,
    },
  },
  COUNTRIES: {
    LIST: `${BASE_ENDPOINTS.COUNTRIES}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.COUNTRIES}/${id}`,
    CREATE: `${BASE_ENDPOINTS.COUNTRIES}`,
    UPDATE: (id: string) => `${BASE_ENDPOINTS.COUNTRIES}/${id}`,
    DELETE: (id: string) => `${BASE_ENDPOINTS.COUNTRIES}/${id}`,
  },
  CAMPAIGNS: {
    LIST: `${BASE_ENDPOINTS.CAMPAIGNS}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.CAMPAIGNS}/${id}`,
    CREATE: `${BASE_ENDPOINTS.CAMPAIGNS}`,
    UPDATE: (id: string) => `${BASE_ENDPOINTS.CAMPAIGNS}/${id}`,
    DELETE: (id: string) => `${BASE_ENDPOINTS.CAMPAIGNS}/${id}`,
  },
  ORGANIZATIONS: {
    LIST: `${BASE_ENDPOINTS.ORGANIZATIONS}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.ORGANIZATIONS}/${id}`,
    CREATE: `${BASE_ENDPOINTS.ORGANIZATIONS}`,
    UPDATE: (id: string) => `${BASE_ENDPOINTS.ORGANIZATIONS}/${id}`,
    DELETE: (id: string) => `${BASE_ENDPOINTS.ORGANIZATIONS}/${id}`,
  },
  TEAMS: {
    LIST: `${BASE_ENDPOINTS.TEAMS}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.TEAMS}/${id}`,
    CREATE: `${BASE_ENDPOINTS.TEAMS}`,
    UPDATE: (id: string) => `${BASE_ENDPOINTS.TEAMS}/${id}`,
    DELETE: (id: string) => `${BASE_ENDPOINTS.TEAMS}/${id}`,
  },
  MEMBERSHIPS: {
    LIST: `${BASE_ENDPOINTS.MEMBERSHIPS}`,
    DETAIL: (id: string) => `${BASE_ENDPOINTS.MEMBERSHIPS}/${id}`,
    CREATE: `${BASE_ENDPOINTS.MEMBERSHIPS}`,
    UPDATE: (id: string) => `${BASE_ENDPOINTS.MEMBERSHIPS}/${id}`,
    DELETE: (id: string) => `${BASE_ENDPOINTS.MEMBERSHIPS}/${id}`,
  },
  OPERATIONS: {
    ACTIVE_CALLS: {
      LIST: `${BASE_ENDPOINTS.ACTIVE_CALLS}`,
      HANGUP: (uuid: string) => `${BASE_ENDPOINTS.ACTIVE_CALLS}/${encodeURIComponent(uuid)}/hangup`,
    },
    CDRS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_CDRS}`,
      UNAUTHORIZED: `${BASE_ENDPOINTS.ADMIN_CDRS}/unauthorized`,
      EXPORT_CSV: `${BASE_ENDPOINTS.ADMIN_CDRS}/export.csv`,
      RECORDING: (id: string) => `${BASE_ENDPOINTS.ADMIN_CDRS}/${encodeURIComponent(id)}/recording`,
      DETECTION_AUDIO: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_CDRS}/${encodeURIComponent(id)}/detection-audio`,
    },
    REPORTS: {
      CONSOLIDATED: `${BASE_ENDPOINTS.ADMIN}/reports/consolidated`,
      CONSOLIDATED_EXPORT_CSV: `${BASE_ENDPOINTS.ADMIN}/reports/consolidated/export.csv`,
      CONSOLIDATED_CAMPAIGNS: `${BASE_ENDPOINTS.ADMIN}/reports/consolidated-campaigns`,
      CONSOLIDATED_CAMPAIGNS_EXPORT_CSV: `${BASE_ENDPOINTS.ADMIN}/reports/consolidated-campaigns/export.csv`,
      DID_ASSIGNMENTS: `${BASE_ENDPOINTS.ADMIN}/reports/did-assignments`,
      DID_ASSIGNMENTS_EXPORT_CSV: `${BASE_ENDPOINTS.ADMIN}/reports/did-assignments/export.csv`,
      TRAFFIC_EXPLORER: `${BASE_ENDPOINTS.ADMIN}/reports/traffic-explorer`,
      TRAFFIC_EXPLORER_SERIES: `${BASE_ENDPOINTS.ADMIN}/reports/traffic-explorer/series`,
      TRAFFIC_EXPLORER_EXPORT: `${BASE_ENDPOINTS.ADMIN}/reports/traffic-explorer/export.csv`,
    },
    CALL_BLOCKS: {
      LIST: (customerId: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${encodeURIComponent(customerId)}/call-blocks`,
      CREATE: (customerId: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${encodeURIComponent(customerId)}/call-blocks`,
      BULK_DELETE: (customerId: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${encodeURIComponent(customerId)}/call-blocks/bulk-delete`,
      DELETE: (customerId: string, blockId: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${encodeURIComponent(customerId)}/call-blocks/${encodeURIComponent(blockId)}`,
    },
    DID_IMPORT_CSV: `${BASE_ENDPOINTS.ADMIN_DIDS}/import`,
    SMTP_CONNECTIONS: `${BASE_ENDPOINTS.ADMIN}/smtp-connections`,
    EMAIL_TEMPLATES: `${BASE_ENDPOINTS.ADMIN}/email-templates`,
    SIGNUP_APPLICATIONS: `${BASE_ENDPOINTS.ADMIN}/signup-applications`,
    TEST_CALLER_IDS: `${BASE_ENDPOINTS.ADMIN}/test-caller-ids`,
    TEST_CALLER_IDS_IMPORT_CSV: `${BASE_ENDPOINTS.ADMIN}/test-caller-ids/import`,
    RESELLERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_RESELLERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_RESELLERS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/archive`,
      RESTORE: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/restore`,
      IMPERSONATE: `${BASE_ENDPOINTS.ADMIN}/impersonate/reseller`,
      USER: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/user`,
      PASSWORD: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/password`,
      PASSWORD_RESET_EMAIL: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/password/reset-email`,
      FUND: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/fund`,
      DEDUCT: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${id}/deduct`,
      DOMAINS: (id: string) => `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${encodeURIComponent(id)}/domains`,
      DOMAIN_PROVISION: (domainId: string) =>
        `${BASE_ENDPOINTS.ADMIN}/reseller-domains/${encodeURIComponent(domainId)}/provision`,
      SIGNUP_LINK_SHARE: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${encodeURIComponent(id)}/signup-link/share`,
      DID_PROVIDERS: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${encodeURIComponent(id)}/did-providers`,
      SIGNUP_INVITATIONS: `${BASE_ENDPOINTS.ADMIN}/reseller-signup-invitations`,
      ADMIN_NOTES: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${encodeURIComponent(id)}/admin-notes`,
      ADMIN_TAGS: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_RESELLERS}/${encodeURIComponent(id)}/admin-tags`,
    },
    TRUNKS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_TRUNKS}`,
    },
    CUSTOMERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}/archive`,
      RESTORE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}/restore`,
      DELETE_PERMANENT: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}/permanent`,
      IMPERSONATE: `${BASE_ENDPOINTS.ADMIN}/impersonate/customer`,
      USER: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}/user`,
      PASSWORD: (id: string) => `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}/password`,
      PASSWORD_RESET_EMAIL: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${id}/password/reset-email`,
      ADMIN_NOTES: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${encodeURIComponent(id)}/admin-notes`,
      ADMIN_TAGS: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_CUSTOMERS}/${encodeURIComponent(id)}/admin-tags`,
    },
    DIDS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_DIDS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_DIDS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_DIDS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_DIDS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_DIDS}/${id}/archive`,
      RESTORE: (id: string) => `${BASE_ENDPOINTS.ADMIN_DIDS}/${id}/restore`,
      TEST: (id: string) => `${BASE_ENDPOINTS.ADMIN_DIDS}/${encodeURIComponent(id)}/test`,
      TEST_RUNS: (id: string) => `${BASE_ENDPOINTS.ADMIN}/test-runs/${encodeURIComponent(id)}`,
    },
    PHONE_NUMBERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_PHONE_NUMBERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_PHONE_NUMBERS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_PHONE_NUMBERS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_PHONE_NUMBERS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_PHONE_NUMBERS}/${id}/archive`,
    },
    DID_PROVIDERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_DID_PROVIDERS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_DID_PROVIDERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_DID_PROVIDERS}/${id}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_DID_PROVIDERS}/${id}`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN_DID_PROVIDERS}/${id}`,
    },
    DID_SUSPENSIONS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_DID_SUSPENSIONS}`,
      EXPORT_CSV: `${BASE_ENDPOINTS.ADMIN_DID_SUSPENSIONS}/export.csv`,
      REACTIVATE: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_DID_SUSPENSIONS}/${encodeURIComponent(id)}/reactivate`,
    },
    CAMPAIGNS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_CAMPAIGNS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_CAMPAIGNS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_CAMPAIGNS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CAMPAIGNS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CAMPAIGNS}/${id}/archive`,
      ANALYTICS: (id: string) => `${BASE_ENDPOINTS.ADMIN_CAMPAIGNS}/${id}/analytics`,
    },
    BUYERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_BUYERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYERS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_BUYERS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYERS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYERS}/${id}/archive`,
    },
    CALL_VENDORS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_CALL_VENDORS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_CALL_VENDORS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CALL_VENDORS}/${id}`,
    },
    CAMPAIGN_BUYERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_CAMPAIGN_BUYERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_CAMPAIGN_BUYERS}/${id}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_CAMPAIGN_BUYERS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_CAMPAIGN_BUYERS}/${id}`,
    },
    LCR: {
      OUTBOUND_PROVIDERS: `${BASE_ENDPOINTS.ADMIN_OUTBOUND_PROVIDERS}`,
      RATE_DECKS: `${BASE_ENDPOINTS.ADMIN_PROVIDER_RATE_DECKS}`,
      TRUNKS: `${BASE_ENDPOINTS.ADMIN_PROVIDER_TRUNKS}`,
      RATES: `${BASE_ENDPOINTS.ADMIN_PROVIDER_RATES}`,
      RESELLER_DEFAULT_TRUNK: `${BASE_ENDPOINTS.ADMIN_RESELLER_DEFAULT_TRUNK}`,
    },
    IPQS: {
      CARRIER_BLOCKS: `${BASE_ENDPOINTS.ADMIN_IPQS_CARRIER_BLOCKS}`,
      CARRIER_BLOCK: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_IPQS_CARRIER_BLOCKS}/${encodeURIComponent(id)}`,
      POLICY: `${BASE_ENDPOINTS.ADMIN_IPQS_POLICY}`,
      POLICY_KEY: (key: string) => `${BASE_ENDPOINTS.ADMIN_IPQS_POLICY}/${encodeURIComponent(key)}`,
    },
    BUYER_GROUPS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}/${id}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}/${id}/archive`,
      MEMBERS: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}/${id}/members`,
      ADD_MEMBER: (id: string) => `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}/${id}/members`,
      REMOVE_MEMBER: (groupId: string, buyerId: string) =>
        `${BASE_ENDPOINTS.ADMIN_BUYER_GROUPS}/${groupId}/members/${buyerId}`,
    },
    BILLING: {
      SUMMARY: `${BASE_ENDPOINTS.ADMIN_BILLING}/summary`,
      LEDGER: `${BASE_ENDPOINTS.ADMIN_BILLING}/ledger`,
      LEDGER_EXPORT_CSV: `${BASE_ENDPOINTS.ADMIN_BILLING}/ledger/export.csv`,
      DID_RENTALS: `${BASE_ENDPOINTS.ADMIN_BILLING}/did-rentals`,
      TRANSFER_BALANCE: `${BASE_ENDPOINTS.ADMIN_BILLING}/transfer-balance`,
      BALANCE_TRANSFERS: `${BASE_ENDPOINTS.ADMIN_BILLING}/balance-transfers`,
    },
    FINANCE: {
      PAYMENTS: `${ADMIN}/finance/payments`,
    },
    INVOICES: {
      LIST: `${BASE_ENDPOINTS.ADMIN_INVOICES}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_INVOICES}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}`,
      ADD_ITEM: (id: string) => `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/items`,
      ADD_ITEMS_FROM_LEDGER: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/items/from-ledger`,
      ISSUE: (id: string) => `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/issue`,
      MARK_PAID: (id: string) => `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/mark-paid`,
      EXPORT_CSV: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/export.csv`,
      HTML: (id: string) => `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/html`,
      PDF: (id: string) => `${BASE_ENDPOINTS.ADMIN_INVOICES}/${encodeURIComponent(id)}/pdf`,
    },
    WITHDRAWALS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_WITHDRAWALS}`,
      APPROVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_WITHDRAWALS}/${encodeURIComponent(id)}/approve`,
      DENY: (id: string) => `${BASE_ENDPOINTS.ADMIN_WITHDRAWALS}/${encodeURIComponent(id)}/deny`,
    },
  },
  ADMIN: {
    SETTINGS: {
      PAYMENTS: `${BASE_ENDPOINTS.ADMIN_SETTINGS}/payments`,
      RECORDING: `${BASE_ENDPOINTS.ADMIN_SETTINGS}/recording`,
      ROUTING: `${BASE_ENDPOINTS.ADMIN_SETTINGS}/routing`,
      DEFAULT_OUTBOUND_TRUNK: `${BASE_ENDPOINTS.ADMIN_SETTINGS}/default-outbound-trunk`,
      SIGNUP_NOTIFICATIONS: `${BASE_ENDPOINTS.ADMIN_SETTINGS}/signup-notifications`,
    },
    USERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_USERS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_USERS}`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}`,
      ARCHIVE: (id: string) => `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}/archive`,
      RESTORE: (id: string) => `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}/restore`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}`,
      PASSWORD: (id: string) => `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}/password`,
      API_TOKENS: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}/api-tokens`,
      AUTH_SESSIONS: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}/auth-sessions`,
      AUTH_HISTORY: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_USERS}/${encodeURIComponent(id)}/auth-history`,
    },
    SMTP: {
      LIST: `${BASE_ENDPOINTS.ADMIN}/smtp-connections`,
      CREATE: `${BASE_ENDPOINTS.ADMIN}/smtp-connections`,
      DETAIL: (id: string) => `${BASE_ENDPOINTS.ADMIN}/smtp-connections/${encodeURIComponent(id)}`,
      TEST: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN}/smtp-connections/${encodeURIComponent(id)}/test`,
    },
    EMAIL_TEMPLATES: {
      LIST: `${BASE_ENDPOINTS.ADMIN}/email-templates`,
      CREATE: `${BASE_ENDPOINTS.ADMIN}/email-templates`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN}/email-templates/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN}/email-templates/${encodeURIComponent(id)}`,
      PREVIEW: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN}/email-templates/${encodeURIComponent(id)}/preview`,
    },
    SIGNUP_APPLICATIONS: {
      LIST: `${BASE_ENDPOINTS.ADMIN}/signup-applications`,
      DETAIL: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN}/signup-applications/${encodeURIComponent(id)}`,
      KYC: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN}/signup-applications/${encodeURIComponent(id)}/kyc`,
      APPROVE: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN}/signup-applications/${encodeURIComponent(id)}/approve`,
      REJECT: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN}/signup-applications/${encodeURIComponent(id)}/reject`,
    },
    TEST_CALLER_IDS: {
      LIST: `${BASE_ENDPOINTS.ADMIN}/test-caller-ids`,
      IMPORT_CSV: `${BASE_ENDPOINTS.ADMIN}/test-caller-ids/import`,
      PATCH: (id: string) => `${BASE_ENDPOINTS.ADMIN}/test-caller-ids/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN}/test-caller-ids/${encodeURIComponent(id)}`,
      BULK_DELETE: `${BASE_ENDPOINTS.ADMIN}/test-caller-ids/bulk-delete`,
    },
    TOKENS: {
      CREATE: `${BASE_ENDPOINTS.ADMIN_TOKENS}`,
    },
    IMPERSONATION: {
      RESELLER: `${BASE_ENDPOINTS.ADMIN_IMPERSONATE}/reseller`,
      CUSTOMER: `${BASE_ENDPOINTS.ADMIN_IMPERSONATE}/customer`,
    },
  },
  RESELLER: {
    CUSTOMERS: {
      LIST: `${RESELLER}/customers`,
      CREATE: `${RESELLER}/customers`,
      RATES: (id: string) => `${RESELLER}/customers/${encodeURIComponent(id)}/rates`,
      PERMISSIONS: (id: string) => `${RESELLER}/customers/${encodeURIComponent(id)}/permissions`,
      PROVIDERS: (id: string) => `${RESELLER}/customers/${encodeURIComponent(id)}/providers`,
      COUNTRIES: (id: string) => `${RESELLER}/customers/${encodeURIComponent(id)}/countries`,
      USER: (id: string) => `${RESELLER}/customers/${encodeURIComponent(id)}/user`,
      PASSWORD: (id: string) => `${RESELLER}/customers/${encodeURIComponent(id)}/password`,
      ALLOCATE_BALANCE: (id: string) =>
        `${RESELLER}/customers/${encodeURIComponent(id)}/allocate-balance`,
      TRANSFER_BALANCE: `${RESELLER}/customers/transfer-balance`,
    },
    DID_PROVIDERS: {
      LIST: `${RESELLER}/did-providers`,
    },
    DID_COUNTRIES: {
      LIST: `${RESELLER}/did-countries`,
    },
    NUMBERS: {
      LIST: `${RESELLER}/numbers`,
      BUY: `${RESELLER}/numbers/buy`,
      IMPORT_CSV: `${RESELLER}/numbers/import`,
      BULK_ARCHIVE: `${RESELLER}/numbers/bulk-archive`,
      ARCHIVE: (id: string) => `${RESELLER}/numbers/${encodeURIComponent(id)}/archive`,
      TEST: (id: string) => `${RESELLER}/numbers/${encodeURIComponent(id)}/test`,
      PATCH: (id: string) => `${RESELLER}/numbers/${encodeURIComponent(id)}`,
    },
    DID_SUSPENSIONS: {
      LIST: `${RESELLER}/did-suspensions`,
      EXPORT_CSV: `${RESELLER}/did-suspensions/export.csv`,
    },
    TEST_RUNS: (id: string) => `${RESELLER}/test-runs/${encodeURIComponent(id)}`,
    CDRS: {
      LIST: `${RESELLER}/cdrs`,
      EXPORT_CSV: `${RESELLER}/cdrs/export.csv`,
      RECORDING: (id: string) => `${RESELLER}/cdrs/${encodeURIComponent(id)}/recording`,
      DETECTION_AUDIO: (id: string) => `${RESELLER}/cdrs/${encodeURIComponent(id)}/detection-audio`,
    },
    CALL_BLOCKS: {
      LIST: (customerId: string) =>
        `${RESELLER}/customers/${encodeURIComponent(customerId)}/call-blocks`,
      CREATE: (customerId: string) =>
        `${RESELLER}/customers/${encodeURIComponent(customerId)}/call-blocks`,
      BULK_DELETE: (customerId: string) =>
        `${RESELLER}/customers/${encodeURIComponent(customerId)}/call-blocks/bulk-delete`,
      DELETE: (customerId: string, blockId: string) =>
        `${RESELLER}/customers/${encodeURIComponent(customerId)}/call-blocks/${encodeURIComponent(blockId)}`,
    },
    REPORTS: {
      CAMPAIGN_SUMMARY: `${RESELLER}/reports/campaign-summary`,
      CAMPAIGN_SUMMARY_EXPORT: `${RESELLER}/reports/campaign-summary/export.csv`,
      CONSOLIDATED: `${RESELLER}/reports/consolidated`,
      CONSOLIDATED_EXPORT_CSV: `${RESELLER}/reports/consolidated/export.csv`,
      CONSOLIDATED_CAMPAIGNS: `${RESELLER}/reports/consolidated-campaigns`,
      CONSOLIDATED_CAMPAIGNS_EXPORT_CSV: `${RESELLER}/reports/consolidated-campaigns/export.csv`,
      TRAFFIC_EXPLORER: `${RESELLER}/reports/traffic-explorer`,
      TRAFFIC_EXPLORER_SERIES: `${RESELLER}/reports/traffic-explorer/series`,
      TRAFFIC_EXPLORER_EXPORT: `${RESELLER}/reports/traffic-explorer/export.csv`,
    },
    BILLING: {
      SUMMARY: `${RESELLER}/billing/summary`,
      LEDGER: `${RESELLER}/billing/ledger`,
      LEDGER_EXPORT_CSV: `${RESELLER}/billing/ledger/export.csv`,
      DID_RENTALS: `${RESELLER}/billing/did-rentals`,
      CUSTOMER_SUMMARY: `${RESELLER}/billing/customer-summary`,
      CUSTOMER_SUMMARY_EXPORT_CSV: `${RESELLER}/billing/customer-summary/export.csv`,
      CUSTOMER_NUMBER_PURCHASES: (customerId: string) =>
        `${RESELLER}/billing/customers/${encodeURIComponent(customerId)}/number-purchases`,
      PAYMENT_CURRENCIES: `${RESELLER}/billing/payment-currencies`,
      PAYMENT_LINK: `${RESELLER}/billing/payment-link`,
    },
    INVOICES: {
      LIST: `${RESELLER}/invoices`,
      DETAIL: (id: string) => `${RESELLER}/invoices/${encodeURIComponent(id)}`,
      HTML: (id: string) => `${RESELLER}/invoices/${encodeURIComponent(id)}/html`,
      PDF: (id: string) => `${RESELLER}/invoices/${encodeURIComponent(id)}/pdf`,
    },
    WITHDRAWALS: {
      LIST: `${RESELLER}/withdrawals`,
      MESSAGES: (id: string) => `${RESELLER}/withdrawals/${encodeURIComponent(id)}/messages`,
    },
    DID_TRANSFERS: {
      LIST: `${RESELLER}/did-transfers`,
      TRANSFER: (didId: string) => `${RESELLER}/dids/${encodeURIComponent(didId)}/transfer`,
    },
    BALANCE_TRANSFERS: {
      LIST: `${RESELLER}/balance-transfers`,
    },
    FINANCE: {
      PAYMENTS: `${RESELLER}/finance/payments`,
    },
    SMTP: `${RESELLER}/smtp`,
    SMTP_TEST: `${RESELLER}/smtp/test`,
    PROFILE: `${RESELLER}/profile`,
    DOMAINS: `${RESELLER}/domains`,
    DOMAIN_PROVISION: (id: string) => `${RESELLER}/domains/${encodeURIComponent(id)}/provision`,
    IMPERSONATE_CUSTOMER: `${RESELLER}/impersonate/customer`,
  },
  VENDOR_PANEL: {
    CDRS: {
      LIST: `${VENDOR_PANEL}/cdrs`,
      EXPORT_CSV: `${VENDOR_PANEL}/cdrs/export.csv`,
      RECORDING: (id: string) => `${VENDOR_PANEL}/cdrs/${encodeURIComponent(id)}/recording`,
    },
    METRICS: `${VENDOR_PANEL}/metrics`,
    DIDS: {
      LIST: `${VENDOR_PANEL}/dids`,
    },
    ACTIVE_CALLS: `${VENDOR_PANEL}/active-calls`,
  },
  BUYER_PANEL: {
    DASHBOARD: `${BUYER_PANEL}/dashboard`,
    CALLS_TIMESERIES: `${BUYER_PANEL}/dashboard/calls-timeseries`,
    ACTIVE_CALLS: `${BUYER_PANEL}/active-calls`,
    TARGETS: `${BUYER_PANEL}/targets`,
    TARGET: (id: string) => `${BUYER_PANEL}/targets/${encodeURIComponent(id)}`,
    CDRS: {
      LIST: `${BUYER_PANEL}/cdrs`,
      EXPORT_CSV: `${BUYER_PANEL}/cdrs/export.csv`,
      RECORDING: (id: string) => `${BUYER_PANEL}/cdrs/${encodeURIComponent(id)}/recording`,
    },
    METRICS: `${BUYER_PANEL}/metrics`,
  },
  CUSTOMER: {
    BILLING: {
      PAYMENT_CURRENCIES: `${CUSTOMER}/billing/payment-currencies`,
      PAYMENT_LINK: `${CUSTOMER}/billing/payment-link`,
      LEDGER_EXPORT_CSV: `${CUSTOMER}/billing/ledger/export.csv`,
    },
    NOTIFICATION_SETTINGS: `${CUSTOMER}/notification-settings`,
    API_TOKENS: {
      LIST: `${CUSTOMER}/api-tokens`,
      CREATE: `${CUSTOMER}/api-tokens`,
      REVOKE: (id: string) => `${CUSTOMER}/api-tokens/${encodeURIComponent(id)}`,
    },
    FINANCE: {
      PAYMENTS: `${CUSTOMER}/finance/payments`,
    },
    CDRS: {
      LIST: `${BASE_ENDPOINTS.CUSTOMER}/cdrs`,
      EXPORT_CSV: `${BASE_ENDPOINTS.CUSTOMER}/cdrs/export.csv`,
      RECORDING: (id: string) => `${BASE_ENDPOINTS.CUSTOMER}/cdrs/${encodeURIComponent(id)}/recording`,
      DETECTION_AUDIO: (id: string) =>
        `${BASE_ENDPOINTS.CUSTOMER}/cdrs/${encodeURIComponent(id)}/detection-audio`,
    },
    CALL_BLOCKS: {
      LIST: `${CUSTOMER}/call-blocks`,
      CREATE: `${CUSTOMER}/call-blocks`,
      BULK_DELETE: `${CUSTOMER}/call-blocks/bulk-delete`,
      DELETE: (blockId: string) => `${CUSTOMER}/call-blocks/${encodeURIComponent(blockId)}`,
    },
    CAMPAIGNS: {
      LIST: `${CUSTOMER}/campaigns`,
      ANALYTICS: (id: string) => `${CUSTOMER}/campaigns/${encodeURIComponent(id)}/analytics`,
    },
    CALL_VENDORS: {
      LIST: `${CUSTOMER}/call-vendors`,
      CREATE: `${CUSTOMER}/call-vendors`,
      UPDATE: (id: string) => `${CUSTOMER}/call-vendors/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `${CUSTOMER}/call-vendors/${encodeURIComponent(id)}`,
    },
    NUMBERS: {
      PATCH: (id: string) => `${CUSTOMER}/numbers/${encodeURIComponent(id)}`,
      ARCHIVE: (id: string) => `${CUSTOMER}/numbers/${encodeURIComponent(id)}/archive`,
      BULK_ARCHIVE: `${CUSTOMER}/numbers/bulk-archive`,
      TEST_RUNS: (id: string) => `${CUSTOMER}/numbers/${encodeURIComponent(id)}/test-runs`,
      TEST: (id: string) => `${CUSTOMER}/numbers/${encodeURIComponent(id)}/test`,
    },
    DIDS: {
      LIST: `${CUSTOMER}/dids`,
      ASSIGN_CAMPAIGN: (didId: string) =>
        `${CUSTOMER}/dids/${encodeURIComponent(didId)}/assign-campaign`,
    },
    DID_SUSPENSIONS: {
      LIST: `${CUSTOMER}/did-suspensions`,
      EXPORT_CSV: `${CUSTOMER}/did-suspensions/export.csv`,
    },
    TEST_RUNS: (id: string) => `${CUSTOMER}/test-runs/${encodeURIComponent(id)}`,
    INVOICES: {
      LIST: `${CUSTOMER}/invoices`,
      DETAIL: (id: string) => `${CUSTOMER}/invoices/${encodeURIComponent(id)}`,
      HTML: (id: string) => `${CUSTOMER}/invoices/${encodeURIComponent(id)}/html`,
      PDF: (id: string) => `${CUSTOMER}/invoices/${encodeURIComponent(id)}/pdf`,
    },
    DAILY_REPORTS: {
      SETTINGS: `${CUSTOMER}/daily-reports/settings`,
      GENERATE_NOW: `${CUSTOMER}/daily-reports/generate-now`,
      CAMPAIGN_SCHEDULES: `${CUSTOMER}/campaign-daily-reports`,
      CAMPAIGN_SCHEDULE: (id: string) =>
        `${CUSTOMER}/campaign-daily-reports/${encodeURIComponent(id)}`,
      CAMPAIGN_SCHEDULE_GENERATE_NOW: (id: string) =>
        `${CUSTOMER}/campaign-daily-reports/${encodeURIComponent(id)}/generate-now`,
      CAMPAIGN_SCHEDULE_DOWNLOAD: (id: string) =>
        `${CUSTOMER}/campaign-daily-reports/${encodeURIComponent(id)}/download`,
    },
    GENERATED_REPORTS: {
      LIST: `${CUSTOMER}/generated-reports`,
      CREATE: `${CUSTOMER}/generated-reports`,
      DOWNLOAD: (id: string) => `${CUSTOMER}/generated-reports/${encodeURIComponent(id)}/download`,
    },
    REPORTS: {
      CONSOLIDATED_CAMPAIGNS: `${CUSTOMER}/reports/consolidated-campaigns`,
      CONSOLIDATED_CAMPAIGNS_EXPORT_CSV: `${CUSTOMER}/reports/consolidated-campaigns/export.csv`,
      TRAFFIC_EXPLORER: `${CUSTOMER}/reports/traffic-explorer`,
      TRAFFIC_EXPLORER_SERIES: `${CUSTOMER}/reports/traffic-explorer/series`,
      TRAFFIC_EXPLORER_EXPORT: `${CUSTOMER}/reports/traffic-explorer/export.csv`,
    },
  },
  SUPPORT: {
    CONVERSATIONS: {
      LIST: `${API_V1}/support/conversations`,
      CREATE: `${API_V1}/support/conversations`,
      DETAIL: (cuuid: string) => `${API_V1}/support/conversations/${encodeURIComponent(cuuid)}`,
      MESSAGES: (cuuid: string) =>
        `${API_V1}/support/conversations/${encodeURIComponent(cuuid)}/messages`,
    },
    EVENTS: {
      STREAM: `${API_V1}/support/events/stream`,
    },
  },
  FREESWITCH: {
    PROFILES: {
      LIST: `${BASE_ENDPOINTS.ADMIN_SOFIA_PROFILES}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_SOFIA_PROFILES}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_SOFIA_PROFILES}/${id}`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN_SOFIA_PROFILES}/${id}`,
    },
    GATEWAYS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_SOFIA_GATEWAYS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_SOFIA_GATEWAYS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_SOFIA_GATEWAYS}/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN_SOFIA_GATEWAYS}/${encodeURIComponent(id)}`,
      ARCHIVE: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_SOFIA_GATEWAYS}/${encodeURIComponent(id)}/archive`,
    },
    TRUNKS: {
      PROVIDERS: `${BASE_ENDPOINTS.ADMIN_OUTBOUND_PROVIDERS}`,
      RATE_DECKS: `${BASE_ENDPOINTS.ADMIN_PROVIDER_RATE_DECKS}`,
      LIST: `${BASE_ENDPOINTS.ADMIN_PROVIDER_TRUNKS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_PROVIDER_TRUNKS}`,
      UPDATE: (id: string) => `${BASE_ENDPOINTS.ADMIN_PROVIDER_TRUNKS}/${encodeURIComponent(id)}`,
      DELETE: (id: string) => `${BASE_ENDPOINTS.ADMIN_PROVIDER_TRUNKS}/${encodeURIComponent(id)}`,
      ARCHIVE: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_PROVIDER_TRUNKS}/${encodeURIComponent(id)}/archive`,
    },
    APPLY: {
      VERSIONS: `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SOFIA}/versions`,
      VALIDATE: `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SOFIA}/validate`,
      GENERATE: `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SOFIA}/generate`,
      APPLY: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SOFIA}/apply/${encodeURIComponent(id)}`,
    },
    SERVERS: {
      LIST: `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SERVERS}`,
      CREATE: `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SERVERS}`,
      UPDATE: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SERVERS}/${encodeURIComponent(id)}`,
      TEST_ESL: (id: string) =>
        `${BASE_ENDPOINTS.ADMIN_FREESWITCH_SERVERS}/${encodeURIComponent(id)}/test-esl`,
    },
  },
};
